export const initialState = {
	commands: [],
	path: "root@girish:~&nbsp;",
	alert: false,
};
